import React from 'react';
import { PreviewPage } from 'shared';
import { routePaths } from 'services/routing';

export default function HealthPreview() {
  return <PreviewPage backPath={routePaths.health} />;
}
